import { FETCH_ORDERS_BY_USER, FETCH_ORDER, FETCH_DELETED_ORDERS, UPSERT_ORDER, UPDATE_ORDER, DELETE_ORDER, RESTORE_ORDER, PERMANENT_DELETE_ORDER, START_LOADING, END_LOADING } from '../actions/constants'

const initialState = { isLoading: false, orders: [], deletedOrders: [], order: null }

const orders = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true }
    case END_LOADING:
      return { ...state, isLoading: false }
    case FETCH_ORDERS_BY_USER:
      return { ...state, orders: action.payload || [] }
    case FETCH_ORDER:
      return { ...state, order: action.payload }
    case FETCH_DELETED_ORDERS:
      return { ...state, deletedOrders: action.payload || [] }
    case UPSERT_ORDER: {
      const existing = state.orders || []
      const idx = existing.findIndex((o) => o._id === action.payload?._id)
      if (idx >= 0) {
        const next = [...existing]
        next[idx] = action.payload
        return { ...state, orders: next, order: action.payload }
      }
      return { ...state, orders: [...existing, action.payload], order: action.payload }
    }
    case UPDATE_ORDER: {
      const existing = state.orders || []
      const idx = existing.findIndex((o) => o._id === action.payload?._id)
      if (idx >= 0) {
        const next = [...existing]
        next[idx] = action.payload
        return { ...state, orders: next, order: action.payload }
      }
      return { ...state, orders: [...existing, action.payload], order: action.payload }
    }
    case DELETE_ORDER:
      return {
        ...state,
        orders: (state.orders || []).filter((order) => order._id !== action.payload),
        order: state.order?._id === action.payload ? null : state.order,
      }
    case RESTORE_ORDER:
      return {
        ...state,
        deletedOrders: (state.deletedOrders || []).filter((order) => order._id !== action.payload?._id),
      }
    case PERMANENT_DELETE_ORDER:
      return {
        ...state,
        deletedOrders: (state.deletedOrders || []).filter((order) => order._id !== action.payload),
      }
    default:
      return state
  }
}

export default orders
